import React from 'react';
import { ArrowRight, Shield, Droplets } from 'lucide-react';

const Hero = () => {
  const scrollToProducts = () => {
    const element = document.getElementById('products');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      id="home"
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
        background: `linear-gradient(135deg, rgba(10, 14, 26, 0.95) 0%, rgba(18, 24, 39, 0.98) 100%)`,
        overflow: 'hidden',
      }}
    >
      {/* Background Image with Overlay */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundImage: 'url(https://images.pexels.com/photos/4487365/pexels-photo-4487365.jpeg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        opacity: 0.12,
        zIndex: 0,
      }} />

      <div style={{
        maxWidth: '1280px',
        margin: '0 auto',
        padding: '6rem 1.5rem 4rem',
        position: 'relative',
        zIndex: 1,
      }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: '1fr',
          gap: '3rem',
          alignItems: 'center',
        }} className="hero-grid">
          {/* Content */}
          <div>
            <div style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '0.5rem',
              background: 'rgba(236, 236, 117, 0.15)',
              border: '1px solid rgba(236, 236, 117, 0.3)',
              padding: '0.5rem 1rem',
              borderRadius: '50px',
              marginBottom: '1.5rem',
            }}>
              <Shield size={20} style={{ color: '#ECEC75' }} />
              <span style={{ 
                fontSize: '0.875rem', 
                fontWeight: 600,
                color: '#ECEC75',
              }}>
                NOMOISTURE - Premium Container Desiccants
              </span>
            </div>

            <h1 style={{
              fontFamily: "'Crimson Text', serif",
              fontSize: 'clamp(2.5rem, 6vw, 4.5rem)',
              fontWeight: 700,
              color: '#f1f5f9',
              lineHeight: 1.1,
              marginBottom: '1.5rem',
            }}>
              NOMOISTURE Industrial Container Desiccants &amp; Moisture Protection
            </h1>

            <p style={{
              fontSize: 'clamp(1.125rem, 2vw, 1.25rem)',
              color: '#cbd5e1',
              lineHeight: 1.8,
              marginBottom: '2rem',
              maxWidth: '640px',
            }}>
              High-absorption calcium chloride desiccant bags and silica gel pouches engineered to
              prevent container rain in ocean freight, deliver export cargo humidity protection and
              give exporters reliable moisture damage control from warehouse to port.
            </p>

            <div style={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: '1rem',
              marginBottom: '3rem',
            }}>
              <button 
                className="btn-primary"
                onClick={scrollToProducts}
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                }}
              >
                View Our Products
                <ArrowRight size={20} />
              </button>
              <button 
                className="btn-secondary"
                onClick={() => {
                  const element = document.getElementById('contact');
                  if (element) element.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                Get in Touch
              </button>
            </div>

            {/* Features */}
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
              gap: '1.5rem',
              marginTop: '3rem',
            }}>
              {[
                { icon: Shield, title: 'Export-Grade Quality', desc: 'Industrial calcium chloride & silica gel' },
                { icon: Droplets, title: 'High Absorption', desc: 'Stops container rain & humidity damage' },
              ].map((feature, index) => (
                <div key={index} style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '1rem',
                }}>
                  <div style={{
                    background: 'rgba(236, 236, 117, 0.15)',
                    border: '1px solid rgba(236, 236, 117, 0.3)',
                    color: '#ECEC75',
                    padding: '0.75rem',
                    borderRadius: '8px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}>
                    <feature.icon size={24} />
                  </div>
                  <div>
                    <h4 style={{
                      fontSize: '1rem',
                      fontWeight: 600,
                      color: '#f1f5f9',
                      marginBottom: '0.25rem',
                    }}>
                      {feature.title}
                    </h4>
                    <p style={{
                      fontSize: '0.875rem',
                      color: '#cbd5e1',
                      margin: 0,
                    }}>
                      {feature.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @media (min-width: 1024px) {
          .hero-grid {
            grid-template-columns: 1fr 1fr !important;
          }
        }
      `}</style>
    </section>
  );
};

export default Hero;
